import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const salesReportSlice = createSlice({
    name: "salesReport",
    initialState: {
        page: 0,
        pageCount: 0,
        loading: false,
        success: false,
        fail: false,
        summaryData: null,
        batchAssignmentsData: null,
        errorData: null,
    },
    reducers: {
        doGetSalesReportSummaryStart: (state) => {
            state.loading = true;
            state.success = false;
            state.fail = false;
        },
        doGetSalesReportSummarySuccess: (state, action) => {
            state.summaryData = action.payload;
            state.loading = false;
            state.success = true;
            state.fail = false;
        },
        doGetSalesReportSummaryFail: (state, action) => {
            state.summaryData = null;
            state.loading = false;
            state.success = false;
            state.fail = true;
            state.errorData = action.payload;
        },
        doGetBatchAssignmentsStart: (state) => {
            state.loading = true;
            state.success = false;
            state.fail = false;
        },
        doGetBatchAssignmentsSuccess: (state, action) => {
            state.batchAssignmentsData = action.payload.data;
            state.page = action.payload.data?.page;
            state.pageCount = Math.ceil(action.payload.data?.total_row / action.payload.data?.limit);
            state.loading = false;
            state.success = true;
            state.fail = false;
        },
        doGetBatchAssignmentsFail: (state, action) => {
            state.batchAssignmentsData = null;
            state.page = 0;
            state.pageCount = 0;
            state.loading = false;
            state.success = false;
            state.fail = true;
            state.errorData = action.payload;
        },
        resetSalesReportState: (state) => {
            state.success = false;
            state.fail = false;
            state.errorData = null;
        },
    },
});

export const doGetSalesReportSummary = (params = {}) => async (dispatch) => {
    try {
        dispatch(doGetSalesReportSummaryStart());

        let url = `/api/retailer/sales-report/summary`;
        const queryParams = [];

        if (params.date_from) {
            queryParams.push(`date_from=${encodeURIComponent(params.date_from)}`);
        }
        if (params.date_to) {
            queryParams.push(`date_to=${encodeURIComponent(params.date_to)}`);
        }

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const response = await axios.get(url);
        dispatch(doGetSalesReportSummarySuccess(response.data));
    } catch (error) {
        dispatch(doGetSalesReportSummaryFail(error.response));
    }
};

export const doGetBatchAssignments = (params = {}) => async (dispatch) => {
    try {
        dispatch(doGetBatchAssignmentsStart());

        const page = params.page || 1;
        const size = params.size || 15;

        let url = `/api/retailer/transactions/batch-assignments?page=${page}&size=${size}`;

        if (params.date_from) {
            url += `&date_from=${encodeURIComponent(params.date_from)}`;
        }
        if (params.date_to) {
            url += `&date_to=${encodeURIComponent(params.date_to)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetBatchAssignmentsSuccess(response.data));
    } catch (error) {
        dispatch(doGetBatchAssignmentsFail(error.response));
    }
};

export const resetSalesReportStateAction = () => async (dispatch) => {
    dispatch(resetSalesReportState());
};

export const {
    doGetSalesReportSummaryStart,
    doGetSalesReportSummarySuccess,
    doGetSalesReportSummaryFail,
    doGetBatchAssignmentsStart,
    doGetBatchAssignmentsSuccess,
    doGetBatchAssignmentsFail,
    resetSalesReportState,
} = salesReportSlice.actions;

// Selectors
export const getSalesReportSummary = (state) => state.salesReport?.summaryData;
export const getBatchAssignments = (state) => state.salesReport?.batchAssignmentsData;
export const getSalesReportPage = (state) => state.salesReport?.page;
export const getSalesReportPageCount = (state) => state.salesReport?.pageCount;
export const getSalesReportLoading = (state) => state.salesReport?.loading;
export const getSalesReportSuccess = (state) => state.salesReport?.success;
export const getSalesReportFail = (state) => state.salesReport?.fail;
export const getSalesReportError = (state) => state.salesReport?.errorData;

export default salesReportSlice.reducer;